import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import UserService from '../../../Services/userService';

export default class CreditMemoRequestSearchParams extends SearchParamsBase {
  initialize() {
    this.SelectedOfficeIds = OfficeHelper.GetDefaultOfficeIds(parseInt(UserService.GetOfficeIdOfLoggedInUser()));
    this.ClientName = '';
    this.ClientId = '';
    this.CreditMemoRequestId = '';
    this.ClientInvoiceId = '';
    this.CreatedBy = '';
    this.AssignedTo = '';
    this.SelectedStatusCodes = [];
  }

  static fieldsInSearchBox = [
    { fieldName: 'CreditMemoRequestId', label: 'Request ID', className: 'col-6', type: InputTypesEnum.Number },
    {
      fieldName: 'SelectedOfficeIds',
      label: 'Office',
      className: 'col-6',
      type: InputTypesEnum.OfficeOrGroupMultiSelect,
    },
    {
      fieldName: 'SelectedStatusCodes',
      label: 'Status',
      className: 'col-6',
      type: InputTypesEnum.LookupMultiChoice,
      options: 75,
    },
    { fieldName: 'ClientName', label: 'Client Name', className: 'col-6', type: InputTypesEnum.Text },
    { fieldName: 'AssignedTo', label: 'Assigned To', className: 'col-6', type: InputTypesEnum.UserSelect },
    { fieldName: 'ClientId', label: 'Client ID', className: 'col-6', type: InputTypesEnum.Number },
    { fieldName: 'CreatedBy', label: 'Created By', className: 'col-6', type: InputTypesEnum.UserSelect },
    { fieldName: 'ClientInvoiceId', label: 'Client Invoice ID', className: 'col-6', type: InputTypesEnum.Number },
  ];

  static iconName = 'fa-solid fa-search';
  static saveType = 'CreditMemoRequestSearchParams';
  static maxWidth = 1000;
}
